module.exports = __webpack_public_path__ + "static/media/dth.49358378.svg";